import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "../../components/Grid/GridContainer.js";

import Card from "../../components/Card/Card.js";
import GridItem from "../../components/Grid/GridItem.js";
import Button from "../../components/CustomButtons/Button.js";

import { getAllCriteria } from "../../api/apiCriteria.js";
import { editCriteria } from "../../api/apiCriteria.js";
import Criterion from "../../components/Criteria/Criterion";
import { isAuthenticated } from "../../utils/authService";
import { validateCriterion } from "../../utils/criterionValidation";
import { showWarningToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";
import CardBody from "../../components/Card/CardBody";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function EditCriteria() {
  const [criteriaData, setCriteriaData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const retData = await getAllCriteria();
        const data = retData.map((item) => ({
          id: item.id,
          data: item,
        }));
        setCriteriaData(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const history = useHistory(); // Initialize useHistory hook

  const updateCriterionData = (id, newData) => {
    setCriteriaData(
      criteriaData.map((criterion) =>
        criterion.id === id ? { ...criterion, data: newData } : criterion
      )
    );
  };

  const handleSubmit = async () => {
    let dataValid = true;
    for (const criterion of criteriaData) {
      const validation = validateCriterion(criterion.data);

      if (!validation.success) {
        showWarningToast({
          title: validation.title,
          message: validation.message,
        });
        return;
      }

      dataValid = dataValid & validation.success;
    }

    if (dataValid) {
      const dataToSend = criteriaData.map((criterion) => criterion.data);
      try {
        const results = await editCriteria(dataToSend);
        history.push("/admin/showallcriteria");
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      {!isAuthenticated() && (
        <p>Izmjena kriterijuma dozvoljena samo administratorima!</p>
      )}
      {isAuthenticated() && (
        <>
          <ToastContainer />
          <div>
            <GridContainer>
              {criteriaData.map((criterion) => (
                <GridItem
                  xs={12}
                  sm={6}
                  md={3}
                  id={criterion.id}
                  key={criterion.id}
                >
                  <Card>
                    <CardBody>
                      <Criterion
                        key={criterion.id}
                        id={criterion.id}
                        data={criterion.data}
                        updateData={updateCriterionData}
                      />
                    </CardBody>
                  </Card>
                </GridItem>
              ))}
            </GridContainer>
            <Button color="success" onPress={handleSubmit}>
              Sačuvaj izmjene
            </Button>
          </div>
        </>
      )}
    </>
  );
}
